import React, { useMemo, useState } from "react";
import CardItem from "./Carditem.js";

const MAJOR_TAGS = [
  "Python",
  "Java",
  "Spring Boot",
  "JavaScript",
  "React",
  "Node",
  "Express",
  "MongoDB",
  "MySQL",
  "HTML",
  "CSS",
  "Machine Learning",
];

export default function Projects({ data }) {
  const projects = data.project || [];
  const [query, setQuery] = useState("");
  const [activeTag, setActiveTag] = useState("All");

  const tags = useMemo(() => {
    return ["All", ...MAJOR_TAGS];
  }, []);

  const filtered = projects.filter((project) => {
    const matchesQuery =
      project.title.toLowerCase().includes(query.toLowerCase()) ||
      project.description.toLowerCase().includes(query.toLowerCase()) ||
      project.tech.toLowerCase().includes(query.toLowerCase());

    const matchesTag =
      activeTag === "All" || project.tech.toLowerCase().includes(activeTag.toLowerCase());

    return matchesQuery && matchesTag;
  });

  document.title = "Projects - Aritra";
  return (
    <div className="page container-narrow">
      <section className="section-tight">
        <p className="eyebrow">Projects</p>
        <h2 className="section-title">Builds that show my range</h2>
        <p className="muted">
          Filter by tech, search by keyword, and explore the repos or live demos.
        </p>
        <div className="glass p-3 mt-4">
          <div className="d-flex flex-wrap gap-3 align-items-center">
            <input
              className="form-control"
              style={{ maxWidth: "320px", background: "#0f172a", color: "#e6edf6", border: "1px solid rgba(148, 163, 184, 0.3)" }}
              placeholder="Search projects"
              value={query}
              onChange={(event) => setQuery(event.target.value)}
            />
            <div className="d-flex flex-wrap gap-2">
              {tags.map((tag) => (
                <button
                  key={tag}
                  type="button"
                  className={`tag ${activeTag === tag ? "active" : ""}`}
                  onClick={() => setActiveTag(tag)}
                >
                  {tag}
                </button>
              ))}
            </div>
          </div>
          <p className="muted mt-3">Showing {filtered.length} projects</p>
        </div>
      </section>

      <section className="section-tight">
        <div className="row g-4">
          {filtered.map((project) => (
            <div className="col-md-4" key={project.title}>
              <CardItem
                title={project.title}
                description={project.description}
                date={project.date}
                tech={project.tech}
                project_url={project.project_url}
              />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
